<template>
  <div class="box">
    <div class="vehicle_panel">
      <div class="complete" v-if="showTopBtn">
        <span @click.stop="vehicleTap('close')">完成</span>
      </div>
      <!--省份简写键盘-->
      <div v-if="keyBoardType == 1">
        <div class="vehicle_panel_row">
          <span
            class="vehicle_panel_row_button"
            v-for="(item,index) in keyVehicle1"
            :key="item"
            @click.stop="vehicleTap(item)"
          >{{item}}
           <span class="relativeBtn" v-if="currentClick===item">
             {{item}}
           </span>
         </span>
        </div>
        <div class="vehicle_panel_row">
          <span
            class="vehicle_panel_row_button"
            v-for="item in keyVehicle2"
            :key="item"
            @click.stop="vehicleTap(item)"
          >{{item}}
          <span class="relativeBtn" v-if="currentClick===item">
            {{item}}
          </span>
         </span>

        </div>
        <div class="vehicle_panel_row">
          <span
            class="vehicle_panel_row_button"
            v-for="item in keyVehicle3"
            :key="item"
            @click.stop="vehicleTap(item)"
          >{{item}}
          <span class="relativeBtn" v-if="currentClick===item">
            {{item}}
          </span>
        </span>
        </div>
        <div class="vehicle_panel_row">
          <span
            class="vehicle_panel_row_button"
            v-for="item in keyVehicle4"
            :key="item"
            @click.stop="vehicleTap(item)"
          >{{item}}
          <span class="relativeBtn" v-if="currentClick===item">
            {{item}}
          </span>
          </span>
          <div
            :class="['vehicle_panel_row_button','vehicle_panel_row_button_last',currentClick=='delete'?'delete_active':'']"
            @click.stop="vehicleTap('delete')"
          >
            <img
              src="../../../assets/images/icon_keyboard_clear.png"
              class="vehicle_en_button_delete"
              @click.stop="vehicleTap('delete')"
            >
          </div>
        </div>
      </div>
      <!--英文键盘-->
      <div v-else>
        <div class="vehicle_panel_row">
          <div
            :class="['vehicle_panel_row_button',numClick==1?'':'disabled']"
            @click.stop="vehicleTap(item,numClick)"
            v-for="item in keyNumber"
            :key="item"
          >{{item}}
          <span class="relativeBtn" v-if="currentClick===item">
            {{item}}
          </span>
        </div>
        </div>
        <div class="vehicle_panel_row">
          <!-- <div
          :class="['vehicle_panel_row_button',item=='O'?'disabled':'']"
          @click.stop="vehicleTap(item,(item=='O'?2:1))" -->

          <div
            :class="['vehicle_panel_row_button']"
            @click.stop="vehicleTap(item,(1))"
            v-for="item in keyEnInput1"
            :key="item"
          >{{item}}
          <span class="relativeBtn" v-if="currentClick===item">
            {{item}}
          </span>
        </div>
        </div>
        <div class="vehicle_panel_row">
          <div
            class="vehicle_panel_row_button"
            @click.stop="vehicleTap(item)"
            v-for="item in keyEnInput2"
            :key="item"
          >{{item}}
          <span class="relativeBtn" v-if="currentClick===item">
            {{item}}
          </span>
        </div>
        </div>
        <div class="vehicle_panel_row">
          <div
            class="vehicle_panel_row_button"
            @click.stop="vehicleTap(item)"
            v-for="item in keyEnInput3"
            :key="item"
          >{{item}}
          <span class="relativeBtn" v-if="currentClick===item">
            {{item}}
          </span>
          </div>
          <div
            :class="['vehicle_panel_row_button',textClick==1?'':'disabled']"
            @click.stop="vehicleTap(item,textClick)"
            v-for="item in keyEnInput4"
            :key="item"
          >{{item}}
          <span class="relativeBtn" v-if="currentClick===item">
            {{item}}
          </span>
          </div>
          <div
            :class="['vehicle_panel_row_button','vehicle_panel_row_button_last',currentClick=='delete'?'delete_active':'']"
            @click.stop="vehicleTap('delete')"
          >
            <img
              src="../../../assets/images/icon_keyboard_clear.png"
              class="vehicle_en_button_delete"
              @click.stop="vehicleTap('delete')"
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'keyboard',
  props: {
    keyBoardType: Number,
    numClick: {
      // 数字键是否可点
      type: Number,
      default: 2
    },
    textClick: {
      // 港澳台是否可点
      type: Number,
      default: 2
    },
    showTopBtn:{
      type:Boolean,
      default:true
    }
  },
  data () {
    return {
      keyVehicle1: ['京', '沪', '粤', '津', '冀', '豫', '云', '辽', '黑', '湘'],
      keyVehicle2: ['皖', '鲁', '新', '苏', '浙', '赣', '鄂', '桂', '甘'],
      keyVehicle3: ['晋', '蒙', '陕', '吉', '闽', '贵', '渝', '川'],
      keyVehicle4: ['青', '藏', '琼', '宁', '使'],
      keyNumber: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '0'],
      keyEnInput1: ['Q', 'W', 'E', 'R', 'T', 'Y', 'U', 'O', 'P', 'A'],
      keyEnInput2: ['S', 'D', 'F', 'G', 'H', 'J', 'K', 'L', 'Z', 'X'],
      keyEnInput3: ['C', 'V', 'B', 'N', 'M'],
      keyEnInput4: ['港', '澳', '学','领'],
      currentClick:""
    }
  },
  methods: {
    vehicleTap (val, status) {
      let self = this;
      if (status === 2) {
        return
      }
      switch (val) {
        case 'delete':
          this.$emit('inputchange',val);
          break;
        case 'ok':
          this.$emit('ok')
          break
        case 'close':
          this.$emit('hideModal')
          break
        default:
          this.$emit('inputchange', val)
          this.currentClick = val
          setTimeout(function(){
            self.currentClick = ''
          },100)
      }
    }
  }
}
</script>
<style lang="less" scoped>
@import "../../../assets/css/common.less";
.vehicle_panel {
  width: 100%;
  /* height: 512px; */
  padding-bottom: 28px;
  display: flex;
  flex-direction: column;
  background: #d6d9de;
}
.complete {
  height: 80px;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  background: #f8f8f8;
  line-height: 80px;
  border-top: 1px solid #eaeaea;
}
.complete span {
  display: block;
  height: 80px;
  line-height: 80px;
  padding: 0 28px;
  color: #0087ff;
  font-weight: bold;
  .fontSize(15px);
}
.isIpx {
  padding-bottom: 68px;
  bottom: -580px;
}
.vehicle_panel_row {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 20px;
  height: 84px;
}
.vehicle_panel_row_button {
  position: relative;
  background-color: #fff;
  margin: 0 6px;
  width: 62px;
  height: 84px;
  text-align: center;
  border-radius: 8px;
  .fontSize(18px);
  color: rgba(0, 0, 0, 1);
  line-height: 84px;
  box-shadow: 0px 2px 0px 0px rgba(4, 4, 15, 0.36);
  .relativeBtn{
    position: absolute;
    left: -15px;
    top: -126px;
    width: 92px;
    height: 112px;
    font-size: 63px;
    border-radius: 16px;
    line-height: 112px;
    background-color: #fff;
    box-shadow: 0px 8px 12px 0px rgba(4, 4, 15, 0.36);
  }
}
.disabled {
  background-color: #eee;
}
.vehicle_panel_row_button_last {
  width: 62px;
  height: 84px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  background: rgba(4, 4, 15, 0.2);
}
.vehicle_hover {
  background-color: #ccc;
}
.vehicle_panel_row_button_img {
  display: flex;
  justify-content: center;
  align-items: center;
}
.vehicle_en_button_delete {
  width: 44px;
  height: 32px;
}
.vehicle_panel_ok {
  background-color: #0f4ba1;
  color: #fff;
  width: 150px;
  height: 80px;
}
.delete_active{
  background: #fff;
}
</style>
